import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { Company } from './company';
import { CompanyComplianceType } from './company-compliance-type';
import { InvitationContact } from './invitation-contact';

export class VendorInvite extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static VendorInviteProperties: (
    | {
        property: keyof VendorInvite;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof VendorInvite;
        type: 'alias';
      }
    | {
        property: keyof VendorInvite;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'CompanyComplianceTypeId', type: 'column', dataType: 'number' },
    { property: 'inviteCode', type: 'column', dataType: 'string' },
    { property: 'inviteEmail', type: 'column', dataType: 'string' },
    { property: 'inviteEmailListCode', type: 'column', dataType: 'string' },
    { property: 'referrer', type: 'column', dataType: 'string' },
    { property: 'isActive', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'Company', model: 'Company', type: 'association' },
    {
      property: 'CompanyComplianceType',
      model: 'CompanyComplianceType',
      type: 'association'
    },
    {
      property: 'InvitationContact',
      model: 'InvitationContact',
      type: 'association'
    }
  ];

  static {
    VendorInvite.VendorInviteProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        VendorInvite.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        VendorInvite.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        VendorInvite.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(VendorInviteObject: Partial<VendorInvite>) {
    super();

    VendorInvite.VendorInviteProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = VendorInviteObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyId?: number;
  CompanyComplianceTypeId?: number;
  inviteCode?: string;
  inviteEmail?: string;
  inviteEmailListCode?: string;
  referrer?: string;
  isActive?: boolean;
  createdAt?: Date;
  updatedAt?: Date;

  Company?: Company;
  CompanyComplianceType?: CompanyComplianceType;
  InvitationContact?: InvitationContact;
}
